import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { CaptchaState } from './types'
import EFetchStatus from '@/utils/enums/fetch-status.enum'
import fetchCaptcha from './async-actions'

const initialState: CaptchaState = {
  code: '',
  status: EFetchStatus.LOADING,
}

const captchaSlice = createSlice({
  name: 'captcha',
  initialState,
  reducers: {
    setCaptcha(state, action: PayloadAction<string>) {
      state.code = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCaptcha.pending, (state) => {
      state.status = EFetchStatus.LOADING
      state.code = ''
      state.imageUrl = ''
      state.hash = ''
    }),
      builder.addCase(fetchCaptcha.fulfilled, (state, action) => {
        state.status = EFetchStatus.SUCCESS
        state.hash = action.payload.hash
        state.imageUrl = action.payload.image_url
      }),
      builder.addCase(fetchCaptcha.rejected, (state) => {
        state.status = EFetchStatus.ERROR
        state.code = ''
        state.imageUrl = ''
        state.hash = ''
      })
  },
})

export const { setCaptcha } = captchaSlice.actions

export default captchaSlice
